module.exports = __webpack_public_path__ + "img/validation-doc.6dce3f2f.svg";